module.exports = __webpack_public_path__ + "static/media/Competition.54340847.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Competition.png
// module id = 1728
// module chunks = 1